<div *ngIf="race">
    <div class="card mb-3">
        <div class="card-body">
            <div class="card-title h4">{{ race.name }}</div>
        </div>
    </div>

    <div class="card mb-3">
        <div class="card-body">
            <div class="card-title h4">Description</div>
            <div class="card-text">
                {{ race.description ? race.description : 'No description provided' }}
            </div>
        </div>
    </div>

    <div class="card mb-3" *ngIf="signedIn && race.owner && race.owner==(user)?.uid">
        <div class="card-body">
            <div class="card-title h4">Admin Options</div>
            <div class="card-text">
                <div class="d-grid gap-3">
                    <button
                        type="button"
                        class="btn btn-outline-primary"
                        (click)="collapse.toggle()"
                        [attr.aria-expanded]="!isCollapsed"
                        aria-controls="collapseExample"
                    >
                        Show Delete Button
                    </button>
                    <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
                        <div class="d-grid col-6 mx-auto">
                            <button (click)="deleteRace()" class="btn btn-outline-danger">Delete Entire Race</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div *ngIf="isOwner" class="card mb-3">
        <div class="card-body">
            <div class="card-title h4">Referees</div>
            <div class="card-text">
                <ul>
                    <li *ngFor="let referee of referees | async" class="mb-3">
                        {{ referee.displayName }}
                        <button class="btn btn-small btn-outline-danger" (click)="removeReferee(referee)">Remove</button>
                    </li>
                </ul>
            </div>

            <div *ngIf="showPagination">
                <hr>
                <ngb-pagination
                [(page)]="refereesPage"
                [pageSize]="refereesPageSize"
                (pageChange)="getReferees()"
                [maxSize]="7" [rotate]="true" [ellipses]="false"
                [collectionSize]="race.referees?.length"></ngb-pagination>
            </div>

            <hr>

            <ng-template #rt let-r="result" let-t="term">
                <ngb-highlight [result]="r.displayName" [term]="t"></ngb-highlight> ({{ r.displayEmail() }})
            </ng-template>

            <fieldset class="row mb-3">
                <label for="typeahead-http" class="col-sm-2 col-form-label">Search to add:</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" id="typeahead-http" [(ngModel)]="newReferee" (ngModelChange)="addReferee()" [editable]='false' [ngbTypeahead]="search" [resultTemplate]="rt" placeholder="Referee Name" [inputFormatter]="formatter">
                  <small *ngIf="searching" class="form-text text-muted">searching...</small>
                </div>
            </fieldset>
        </div>
    </div>

    <div class="card mb-3">
        <div class="card-body">
            <div class="card-title h4 d-flex justify-content-between align-items-center">
                Events
                <span *ngIf="signedIn && race.owner && race.owner==(user)?.uid">
                    <app-event-create [raceId]="race.id" [referees]="race.referees" [redirectOnSuccess]="false"></app-event-create>
                </span>
            </div>
            <div class="card-text">
                <app-event-list [events]="events" *ngIf="(events | async)?.length; else noEvents"></app-event-list>
            </div>
        </div>
    </div>
</div>


<ng-template #noEvents>
    No Events
</ng-template>